import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
var MOUSE_EVENTS_SUPPORTED = ['mouseup', 'touchend'];

var WixComponent = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(WixComponent, _React$PureComponent);

  var _super = _createSuper(WixComponent);

  function WixComponent(params) {
    var _this;

    _classCallCheck(this, WixComponent);

    _this = _super.call(this, params);
    _this._addDataHook = _this._addDataHook.bind(_assertThisInitialized(_this));
    _this._supportOnClickOutside = _this._supportOnClickOutside.bind(_assertThisInitialized(_this));
    _this._onMouseEventsHandler = _this._onMouseEventsHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WixComponent, [{
    key: "checkIfEventOnElements",
    value: function checkIfEventOnElements(e, elem) {
      var current = e.target;

      while (current.parentNode) {
        if (elem.indexOf(current) > -1) {
          return true;
        }

        current = current.parentNode;
      }

      return current !== document;
    }
  }, {
    key: "componentElements",
    value: function componentElements() {
      return [ReactDOM.findDOMNode(this)];
    }
  }, {
    key: "setStyles",
    value: function setStyles(styles) {
      var typography = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.props.styles) {
        this.styles = this.props.styles;
      } else {
        this.styles = styles;
      }

      this.typography = this.props.styles || typography;
    }
  }, {
    key: "_onMouseEventsHandler",
    value: function _onMouseEventsHandler(e) {
      if (!this.checkIfEventOnElements(e, this.componentElements())) {
        this.onClickOutside(e);
      }
    }
  }, {
    key: "_addDataHook",
    value: function _addDataHook(dataHook) {
      var domNode = ReactDOM.findDOMNode(this);

      if (domNode) {
        domNode.setAttribute('data-hook', dataHook);
      }
    }
  }, {
    key: "_supportOnClickOutside",
    value: function _supportOnClickOutside() {
      var _this2 = this;

      MOUSE_EVENTS_SUPPORTED.forEach(function (eventName) {
        document.addEventListener(eventName, _this2._onMouseEventsHandler, true);
      });
      this._boundEvents = MOUSE_EVENTS_SUPPORTED;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var dataHook = this.props.dataHook;

      if (dataHook) {
        this._addDataHook(dataHook);
      }

      if (typeof this.onClickOutside === 'function') {
        this._supportOnClickOutside();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.dataHook !== this.props.dataHook) {
        this._addDataHook(this.props.dataHook);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (this._boundEvents && typeof document !== 'undefined') {
        this._boundEvents.forEach(function (eventName) {
          document.removeEventListener(eventName, _this3._onMouseEventsHandler, true);
        });
      }
    }
  }]);

  return WixComponent;
}(React.PureComponent);

WixComponent.propTypes = {
  dataHook: PropTypes.string,
  styles: PropTypes.string
};
export default WixComponent;